module.exports = [
  {
    title: 'Ремонт электроники',
    info:
      'Современный автомобиль сложно себе представить без электроники. Эти устройства выполняют различную логику. Например следят уровнем масла, количеством топлива которое получает двигатель и т.д. Вся эта информация поступает в центральный блок управления, который хранит, анализирует, управляет большинством узлов автомобиля.',
    items: [
      {
        title: 'Удаление сажевого фильтра',
        info:
          'Мы предлагаем отключение / деактивацию/ удаление сажевого фильтра (DPF/FAP). Одной из причин удаления сажевого фильтра может стать:',
        list: [
          'потеря мощности в нормальном режиме работы двигателя',
          'увеличение расхода топлива',
          'горит ошибка чек'
        ]
      },
      {
        title: 'Удаление EGR',
        info:
          'Система EGR (Система рециркуляции отработавших газов) предназначена для снижения образования оксидов азота, образуемых при работе двигателя. В некоторых случаях использование этой системы начинает негативно влиять на работу двигателя. Наш сервис предоставляет услугу по удалению клапана EGR. Мы предлагаем чистку, отключение EGR в Донецке:',
        list: [
          'програмное отключение клапана EGR',
          'установка заглушки клапана EGR'
        ]
      },
      {
        title: 'Ремонт/замена блока управления',
        info:
          'Блоки управления (ECU) довольно надежны и ломаются редко. Причинами выхода из строя могут является: влага проникшая внутрь корпуса ECU, механические воздействия, неполадки в электропитании.',
        list: [
          'програмное отключение клапана EGR',
          'установка заглушки клапана EGR'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/electronic.js